import { useEffect, useRef, useState } from 'react';

// Whether the signed-in user can open Proposal Studio, so dashboards only show the link to studio members.
// Checked once per mount (AuthContext hands out a new axios instance on every render).
export function useStudioAccess(api) {
  const [allowed, setAllowed] = useState(false);
  const apiRef = useRef(api);
  useEffect(() => {
    let live = true;
    apiRef.current.get('/proposal-studio/me').then(() => live && setAllowed(true)).catch(() => live && setAllowed(false));
    return () => { live = false; };
  }, []);
  return allowed;
}
